<template lang="pug">
	article#unidades
		Banner(nomePagina="Unidades UniFael")
		Texto(:tipo.sync="tipo")
		Filtro(:tipo.sync="tipo", :cidade.sync="cidade", :estado.sync="estado", :endereco.sync="endereco", :cidades="cidades", :estados="estados", :endereco="endereco", @sendEndereco="sendEndereco()")
		Loader(tamanho="large", v-if="carregando").verde
		Mapa(:tipo="tipo", :cidade="cidade", :estado="estado", :endereco="endereco", :cidades="cidades", :estados="estados", v-show="!carregando", ref="mapa")
</template>

<script>
import Banner from '@components/BannerTemplates/BannerTemplates.vue'
import Filtro from '@sections/Unidades/Filtro/Filtro.vue'
import Mapa from '@sections/Unidades/Mapa/Mapa.vue'
import Texto from '@sections/Unidades/Texto/Texto.vue'
import Loader from '@components/Loader/Loader'

import Cidade from '@lib/utilsFael/cidade'
import Estado from '@lib/utilsFael/estado'

import pagina from '@/mixins/pagina'

const GOOGLEMAPS_ID = 'GoogleMapsScript'

export default {
	name: "view-unidades",
	components: {
		Banner,
		Filtro,
		Mapa,
		Loader,
		Texto,
	},
	mixins: [
		pagina
	],
	data() {
		return {
			tipo: 'grad',
			cidade: null,
			estado: null,
			estados: [],
			cidades: [],
			carregando: true,
			endereco:null
		}
	},
	watch: {
		estado: function() {
			this.cidades = []
			this.cidade = null
			if (this.estado != null)
				this.loadCidades(this.estado)
		}
	},
	mounted() {
		this.$eventbus.$on('polos-loaded', () => this.carregando = false)
		if (!document.querySelector(`#${GOOGLEMAPS_ID}`))
			this.insertGoogleMaps(this.$utils.google_maps_api)
		this.loadEstados()
	},
	methods: {
		sendEndereco(){
			this.$refs.mapa.sendEndereco();
		},
		insertGoogleMaps(api_maps) {
			let script = document.createElement('script');
			script.id = GOOGLEMAPS_ID
			script.src = `https://maps.googleapis.com/maps/api/js?key=${api_maps}&language=pt-BR&region=BR`;
			script.onload = () => this.$eventbus.$emit('gmaps-loaded')
			document.querySelector('body').append(script);
		},
		async loadEstados() {
			return await this.$axios
				.get(`convenio/estados`)
				.then(response => this.estados = response.data.map(estado => new Estado(estado)))
        },
		async loadCidades(uf) {
			return await this.$axios
				.get(`estados/${uf}/cidades`)
				.then(response => this.cidades = response.data.map(cidade => new Cidade(cidade, uf)))
        },
	},
}
</script>

<style lang="stylus" scoped src="./Unidades.styl"></style>
